import PropTypes from "prop-types";
import styles from "./AddNoteItem.module.css";
import { useState } from "react";
import classNames from "classnames";

/**
 * Interactive component used when adding or editing a note. A delete button is displayed when editing a note.
 */
export function AddNoteItem({ note, onSave, onCancel, onDelete }) {
  const [currentNote, setCurrentNote] = useState(!note ? "" : note);

  return (
    <div className={styles.addNote}>
      <div className={styles.noteArea}>
        <span
          onInput={(e) => setCurrentNote(e.target.innerText)}
          className={
            !currentNote
              ? classNames(styles.textArea, styles.blankTextArea)
              : classNames(styles.textArea, styles.filledTextArea)
          }
          role="textbox"
          contentEditable="true"
          suppressContentEditableWarning={true}
          dangerouslySetInnerHTML={{ __html: note || "" }}
        />
      </div>
      <div className={styles.buttonSection}>
        <div className={styles.buttonRow}>
          <button
            className={classNames(styles.saveButton, styles.button)}
            onClick={() => onSave(currentNote)}
          >
            Save
          </button>
          <button
            className={classNames(styles.cancelButton, styles.button)}
            onClick={() => onCancel()}
          >
            Cancel
          </button>
        </div>
        {onDelete ? (
          <div className={styles.buttonRow}>
            <button
              className={classNames(
                onDelete ? styles.deleteButton : styles.displayNone,
                styles.button
              )}
              onClick={() => onDelete()}
            >
              Delete
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}

AddNoteItem.propTypes = {
  /**
   * Displays the note if the user is editing .
   */
  note: PropTypes.string,

  /**
   * Function used to save the note.
   */
  onSave: PropTypes.func,

  /**
   * Function used to cancel and close the add note item.
   */
  onCancel: PropTypes.func,

  /**
   * Used to delete the note if user is editing a note item.
   */
  onDelete: PropTypes.func,
};
